import { Controller } from "@hotwired/stimulus"

// Applies body offset so fixed impersonation chrome does not cover the app shell.
export default class extends Controller {
  static classes = [ "active" ]

  connect() {
    document.body.classList.add("has-impersonation-banner")
    this.#syncHeight()
    this.resizeObserver = new ResizeObserver(() => this.#syncHeight())
    this.resizeObserver.observe(this.element)
  }

  disconnect() {
    this.resizeObserver?.disconnect()
    document.body.classList.remove("has-impersonation-banner")
    document.body.style.removeProperty("--impersonation-banner-height")
  }

  #syncHeight() {
    const height = `${this.element.offsetHeight}px`
    document.body.style.setProperty("--impersonation-banner-height", height)
  }
}
